import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { UserUsage } from "@/api/types";

/**
 * Uso agregado (custo via Langfuse + contagens do DB) de qualquer
 * usuario. Admin-only; serve a conta de servico aberta no detalhe.
 */
export function useUserUsage(userId: string) {
  return useQuery({
    queryKey: ["observability", "user-usage", userId],
    queryFn: () =>
      api.GET<UserUsage>(`/observability/users/${userId}`),
    enabled: Boolean(userId),
    staleTime: 60_000,
  });
}
